module.exports = __webpack_public_path__ + "img/contact_phar.6c530c5c.png";